import './DiningMethodsPanel.less';

export const prefix = 'oc-c-dining-methods-panel';

export { default } from './DiningMethodsPanel';